import { render } from "./PostTooltip.vue?vue&type=template&id=b19e6d00&scoped=true"
import script from "./PostTooltip.vue?vue&type=script&lang=js"
export * from "./PostTooltip.vue?vue&type=script&lang=js"

import "./PostTooltip.vue?vue&type=style&index=0&id=b19e6d00&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b19e6d00"]])

export default __exports__